import { render, staticRenderFns } from "./DriveUploader.vue?vue&type=template&id=40660e46&"
import script from "./DriveUploader.vue?vue&type=script&lang=ts&"
export * from "./DriveUploader.vue?vue&type=script&lang=ts&"
import style0 from "./DriveUploader.vue?vue&type=style&index=0&id=40660e46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports